import React, { Component } from "react";
import { withCookies, Cookies } from "react-cookie";
import { instanceOf } from "prop-types";
import { withRouter } from "react-router-dom";
import _ from "lodash";

import postosService from "@services/postos";
import apolloService from "@services/apollo";
import productsService from "@services/products";

import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import "./sync.css";

// Components
import EmpresaSelect from "@components/EmpresaSelect";
import Menu from "@components/Menu";
import Button from "@components/Button";
import Input from "@components/Input";
import Checkbox from "@components/CheckBox";

import { threeDecimal } from "@utils/format.js";
import { currentDateTime, transformDateTime } from "@utils/date";

import UserContext from "@components/context/userContext";

const defaultDate = currentDateTime();

class Page extends Component {
  static contextType = UserContext;

  static propTypes = {
    cookies: instanceOf(Cookies).isRequired,
  };

  constructor(props) {
    super(props);

    this.state = {
      loaded: false,
      warehouses: [],
      date: defaultDate,
      useGlobalDate: true, // Novo estado para controlar se usa data global ou personalizada
      values: {
        columns: [
          {
            label: "Data",
            field: "date",
            width: 200,
          },
          {
            label: "Produto",
            field: "product",
            width: 300,
          },
          {
            label: "Price",
            field: "price",
            width: 200,
          },
        ],
        rows: [],
      },
    };
    this.loadFunction = this.loadFunction.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleFormCancel = this.handleFormCancel.bind(this);
    this.handleFormSubmit = this.handleFormSubmit.bind(this);
  }

  loadFunction() {
    if (!this.state.loaded) {
      const profile = this.context;

      postosService
        .get(profile.idEmpresaSec)
        .then((warehousesData) => {
          const warehouses =
            warehousesData.reduce(
              (accum, warehouse) => ({
                ...accum,
                [warehouse.posto]: warehouse,
              }),
              {}
            );

          apolloService
            .getSync(profile.idEmpresaSec)
            .then((response) => {
              const warehousesSync = response.warehouses || {};

              if (warehousesSync && Object.keys(warehousesSync).length > 0) {
                productsService
                .getPostoProductsByFilter(profile.idEmpresaSec, true, "pv.sync='TRUE'")
                .then((postosWarehouses) => {

                  this.setState({
                    warehouses: Object.keys(warehouses).map((warehouse) => ({
                      date: defaultDate,
                      sameDate: true,
                      ...(warehousesSync[warehouse]
                        ? warehousesSync[warehouse]
                        : warehouses[warehouse]),
                      idposto: warehouse,
                      total: postosWarehouses[warehouse].total,
                      products: _.orderBy(
                        postosWarehouses[warehouse].items.map((product) => ({
                          ...product,
                          new: Object.keys(
                            warehousesSync[warehouse]
                              ? warehousesSync[warehouse].products
                              : {}
                          ).includes(product.idproduct),
                        })),
                        ["new"],
                        ["desc"]
                      ),
                    })),
                    loaded: true,
                  });
                });
              }
            });
        });
    }
  }

  handleChange(e, callback) {
    let value = e.target.value;
    let name = e.target.name;

    let newState = this.state;

    if (name.includes("|")) {
      const properties = name.split("|");

      if (properties[4]) {
        if (properties[4] === "sameDate") {
          newState[properties[0]][properties[1]][properties[2]][properties[3]][
            properties[4]
          ] =
            !newState[properties[0]][properties[1]][properties[2]][
              properties[3]
            ][properties[4]];
        } else {
          newState[properties[0]][properties[1]][properties[2]][properties[3]][
            properties[4]
          ] = value;
        }
      } else if (properties[2]) {
        if (properties[2] === "sameDate") {
          newState[properties[0]][properties[1]][properties[2]] =
            !newState[properties[0]][properties[1]][properties[2]];
        } else {
          newState[properties[0]][properties[1]][properties[2]] = value;
        }
      }

      this.setState({
        ...newState,
      });
    } else {
      if (name === "useGlobalDate") {
        this.setState({
          [name]: !this.state[name],
        });
      } else {
        this.setState({
          [name]: value,
        });
      }
    }
  }

  handleFormCancel() {
    const { history } = this.props;
    history.push("/products");
  }

  handleFormSubmit() {
    confirmAlert({
      title: "Confirmação",
      message: (
        <>
          <p>Todos os preços do Apollo serão substituidos após confirmação.</p>
          <p>
            <b>Tem a certeza que deseja substituir os preços no Apollo?</b>
          </p>
        </>
      ),
      buttons: [
        {
          label: "Sim",
          onClick: () => {
            const profile = this.context;
            const { warehouses, date, useGlobalDate } = this.state;
            const dateTime = transformDateTime(date);

            apolloService
              .performSync(profile.idEmpresaSec, warehouses.reduce((accum, warehouse) => {
                return {
                  ...accum,
                  [warehouse.posto]: useGlobalDate
                    ? dateTime
                    : transformDateTime(warehouse["date"]),
                };
              }, {}))
              .then((response) => {
                window.location.href = "/products";
              });
          },
        },
        {
          label: "Não",
          onClick: () => {},
        },
      ],
    });
  }

  render() {
    const { date, warehouses } = this.state;
    const { location, history } = this.props;
    const cookies = new URLSearchParams(location.search);

    return (
      <div className="sync-page">
        <Menu
          loadFunction={this.loadFunction}
          location={location}
          history={history}
          newCookies={cookies}
        />
        
        {/* Breadcrumb */}
        <div className="fullContainer">
          <div className="col-xs-12">
            <nav className="breadcrumb-nav">
              <ol className="breadcrumb-list">
                <li className="breadcrumb-item">
                  <a href="http://eposgestofinal.com/index.php" className="breadcrumb-link">Portal</a>
                </li>
                <li className="breadcrumb-separator">›</li>
                <li className="breadcrumb-item">
                  <a href="/products" className="breadcrumb-link">Produtos</a>
                </li>
                <li className="breadcrumb-separator">›</li>
                <li className="breadcrumb-item active">Sincronizar com Apollo</li>
              </ol>
            </nav>
          </div>
        </div>

        <EmpresaSelect />

        {/* Main Content */}
        <div className="fullContainer">
          <div className="col-sm-12">
            <div className="main-panel">
              {/* Header */}
              <div className="panel-header">
                <h1 className="panel-title">
                  <span className="title-icon" role="img" aria-label="ícone de sincronização">🔄</span>
                  Sincronizar com Apollo
                </h1>
                <p className="panel-subtitle">Sincronize os preços dos produtos com o sistema Apollo</p>
              </div>

              {warehouses.length > 0 ? (
                <>
                  {/* Configuração Global */}
                  <div className="sync-config-section">
                    <div className="config-header">
                      <h2>Configuração de Sincronização</h2>
                      <p>Defina a data e hora para sincronização dos preços</p>
                    </div>
                    
                    <div className="config-form">
                      <div className="date-config-card">
                        <div className="config-content">
                          {/* Opção de Modo de Data */}
                          <div className="date-mode-selector">
                            <div className="mode-option">
                              <Checkbox
                                name={"useGlobalDate"}
                                title={"Usar data global para todos os postos"}
                                checked={this.state.useGlobalDate}
                                handleChange={this.handleChange}
                              />
                              <span className="mode-label">
                                Usar data global para todos os postos
                              </span>
                            </div>
                          </div>

                          {this.state.useGlobalDate && (
                            <div className="date-input-wrapper">
                              <label className="config-label">
                                Data e Hora Global da Sincronização
                              </label>
                              <Input
                                inputType={"datetime-local"}
                                name={"date"}
                                value={date}
                                handleChange={this.handleChange}
                                className="sync-datetime-input"
                              />
                              <p className="config-hint">
                                Todos os postos usarão esta data para sincronização
                              </p>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>

                    {/* Actions */}
                    <div className="sync-actions">
                      <Button
                        action={this.handleFormCancel}
                        type={"secondary"}
                        title={"Cancelar"}
                        style={{
                          padding: '12px 24px',
                          fontSize: '16px',
                          marginRight: '12px'
                        }}
                      />
                      <Button
                        action={this.handleFormSubmit}
                        type={"success"}
                        title={"Sincronizar Agora"}
                        style={{
                          padding: '12px 24px',
                          fontSize: '16px',
                          fontWeight: '600'
                        }}
                      />
                    </div>
                  </div>

                  {/* Lista de Postos */}
                  <div className="warehouses-sync-container">
                    <div className="section-header">
                      <h2>Postos para Sincronização</h2>
                      <p>
                        {this.state.useGlobalDate 
                          ? 'Todos os postos usarão a data global configurada acima'
                          : 'Configure a data de sincronização individualmente para cada posto'
                        }
                      </p>
                    </div>

                    <div className="warehouses-grid">
                      {warehouses.map((warehouse, index) => {
                        const newProductsCount = warehouse.products.filter(p => p.new).length;
                        const totalProducts = warehouse.products.length;
                        
                        return (
                          <div key={warehouse.posto} className="warehouse-sync-card">
                            {/* Header do Posto */}
                            <div className="warehouse-sync-header">
                              <div className="warehouse-info">
                                <div className="warehouse-badge">#{warehouse.posto}</div>
                                <h3 className="warehouse-title">{warehouse.nome}</h3>
                              </div>
                            </div>

                            {/* Configuração de Data */}
                            {!this.state.useGlobalDate && (
                              <div className="warehouse-date-config">
                                <div className="date-option">
                                  <span className="date-option-label">
                                    Data de sincronização personalizada:
                                  </span>
                                </div>
                                <div className="custom-date-wrapper">
                                  <Input
                                    inputType={"datetime-local"}
                                    key={`warehouses|${index}|date`}
                                    name={`warehouses|${index}|date`}
                                    value={warehouse.date}
                                    handleChange={this.handleChange}
                                    className="custom-date-input"
                                  />
                                </div>
                              </div>
                            )}
                            
                            {this.state.useGlobalDate && (
                              <div className="warehouse-date-config">
                                <div className="date-info">
                                  <span className="date-info-label">
                                    Este posto usará a data global configurada acima
                                  </span>
                                </div>
                              </div>
                            )}

                            {/* Produtos */}
                            <div className="warehouse-products-section">
                              <div className="products-header">
                                <h4>Produtos ({totalProducts})</h4>
                                {newProductsCount > 0 && (
                                  <span className="new-products-badge">
                                    {newProductsCount} novos
                                  </span>
                                )}
                              </div>
                              
                              <div className="products-list">
                                {warehouse.products.map((product) => (
                                  <div 
                                    key={product.idproduct}
                                    className={`product-item ${product.new ? 'new-product' : ''}`}
                                    onClick={() => window.location.href = `/products/${product.idproduct}/prices/sync`}
                                  >
                                    <div className="product-info">
                                      <div className="product-badge">#{product.idproduct}</div>
                                      <div className="product-name">{product.name}</div>
                                    </div>
                                    <div className="product-price">
                                      <span className="price-value">€{threeDecimal(product.price)}</span>
                                      {product.new && (
                                        <span className="new-indicator">Novo</span>
                                      )}
                                    </div>
                                    <div className="product-arrow">→</div>
                                  </div>
                                ))}
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </>
              ) : (
                <div className="no-data-section">
                  <div className="no-data-icon"><span role="img" aria-label="ícone de documento">📋</span></div>
                  <h3>Nenhum dado para sincronizar</h3>
                  <p>De momento não existem dados disponíveis para sincronização com o Apollo.</p>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withCookies(withRouter(Page));
